import React from "react";
import { Icon } from "@iconify/react";
import { Step as StepComponent } from "react-step-progress-bar";
import { useStepState } from "../hooks/use-step-state";
function withImages(Component) {
    return (props) => {
        const { referenceElement, setReferenceElement, popperElement, setPopperElement, attributes, styles } = useStepState();
        return (React.createElement(Component, { transition: "scale", ...props, ref: setReferenceElement }, ({ accomplished }) => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `order-progress-step ${accomplished ? "accomplished" : null}` },
                React.createElement(Icon, { icon: "lucide:check" })),
            React.createElement("div", { ref: setPopperElement, className: "py-1 px-3", style: styles.popper, ...attributes.popper },
                React.createElement("div", { className: "h-[256px] w-[256px] translate-x-[-50%] flex flex-col" },
                    React.createElement("img", { alt: "step-icon", src: props.icon })))))));
    };
}
export const Step = withImages(StepComponent);
